import './styles.scss';
import BenefitCard from './BenefitCard';

const BenefitsCards = ({ data }) => (
    <div className="benefits-container">
        {data.map((item, index) => (
            <BenefitCard key={index} item={item} index={index} />
        ))}
    </div>
);

export default BenefitsCards;
